<template>
    <div class="main">
        <div style="height: 40px; width: 100%; background-color: #f1f2f2; position: relative">
            <span
                style="
                    font-size: 24px;
                    font-weight: 600;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%) translateX(-50%);
                    left: 50%;
                "
                >中国</span
            >
        </div>

        <div style="height: 100%; width: 100%">
            <a-table
                class="table"
                :columns="columns"
                :data-source="data_china"
                :bordered="true"
                size="small"
                :scroll="{ x: '100%' }"
                :pagination="false"
                :row-key="(record, index) => index"
            >
                <template v-for="item in columns" :key="item.key" #[item.key]="{ text }">
                    <span :class="hasVideo(text) ? 'num' : 'num_disable'" @click="showRow(text)">{{ text.value }}</span>
                </template>
            </a-table>
        </div>
        <div style="margin-top: 20px; height: 40px; width: 100%; background-color: #f1f2f2; position: relative">
            <span
                style="
                    font-size: 24px;
                    font-weight: 600;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%) translateX(-50%);
                    left: 50%;
                "
                >日本</span
            >
        </div>
        <div style="height: 100%; width: 100%">
            <a-table
                class="table"
                :columns="columns"
                :data-source="data_japan"
                :bordered="true"
                :scroll="{ x: '100%' }"
                size="small"
                :pagination="false"
                :row-key="(record, index) => index"
            >
                <template v-for="item in columns" :key="item.key" #[item.key]="{ text }">
                    <span :class="hasVideo(text) ? 'num' : 'num_disable'" @click="showRow(text)">{{ text.value }}</span>
                </template>
            </a-table>
        </div>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue'
import videoDialog from '@/components/videoDialog'
import { useRoute } from 'vue-router'

export default defineComponent({
    name: 'PanelData',
    props: {},
    setup() {
        const data = ref([])
        const data_china = ref([])
        const data_japan = ref([])
        const showVideo = ref(false)
        const date = ref('')
        const columns = [
            {
                title: '阵容',
                key: 'pr',
                width: 190,
                dataIndex: 'pr',
                fixed: 'left',
                align: 'center',
                customCell: () => {
                    return { style: { 'font-weight': '600' } }
                },
                customRender: ({ index, text }) => {
                    return {
                        children: text,
                        props: {
                            rowSpan: index % 2 == 0 ? 2 : 0,
                        },
                    }
                },
            },
            {
                title: '国家',
                key: 'country',
                dataIndex: 'country',
                width: 50,
                align: 'center',
            },
            {
                title: '+/-',
                key: 'difference',
                dataIndex: 'difference',
                width: 40,
                align: 'center',
                customRender: ({ index, text }) => {
                    return {
                        children: text,
                        props: {
                            rowSpan: index % 2 == 0 ? 2 : 0,
                        },
                    }
                },
            },
            {
                title: '回合数',
                key: 'round',
                dataIndex: 'round',
                width: 50,
                align: 'center',
            },
            {
                title: '得分',
                key: 'score',
                dataIndex: 'score',
                width: 50,
                align: 'center',
            },
            {
                title: '出手',
                key: 'PA',
                dataIndex: 'PA',
                width: 50,
                align: 'center',
            },
            {
                title: '命中',
                key: 'PM',
                dataIndex: 'PM',
                width: 50,
                align: 'center',
            },
            {
                title: '命中率',
                key: 'Pperc',
                dataIndex: 'Pperc',
                width: 50,
                align: 'center',
            },
            {
                title: '两分出手',
                key: 'TWOPA',
                dataIndex: 'TWOPA',
                width: 50,
                align: 'center',
            },
            {
                title: '两分命中',
                key: 'TWOPM',
                dataIndex: 'TWOPM',
                width: 50,
                align: 'center',
            },
            {
                title: '两分%',
                key: 'TWOperc',
                dataIndex: 'TWOperc',
                width: 53,
                align: 'center',
            },
            {
                title: '三分出手',
                key: 'THREEPA',
                dataIndex: 'THREEPA',
                width: 50,
                align: 'center',
            },
            {
                title: '三分命中',
                key: 'THREEPM',
                dataIndex: 'THREEPM',
                width: 50,
                align: 'center',
            },
            {
                title: '三分%',
                key: 'THREEperc',
                dataIndex: 'THREEperc',
                width: 53,
                align: 'center',
            },
            {
                title: '罚球出手',
                key: 'FTA',
                dataIndex: 'FTA',
                width: 50,
                align: 'center',
            },
            {
                title: '罚球命中',
                key: 'FTM',
                dataIndex: 'FTM',
                width: 50,
                align: 'center',
            },
            {
                title: '罚球%',
                key: 'FTperc',
                dataIndex: 'FTperc',
                width: 53,
                align: 'center',
            },
            {
                title: '篮板',
                key: 'TREB',
                dataIndex: 'TREB',
                width: 50,
                align: 'center',
            },
            {
                title: '进攻篮板',
                key: 'OREB',
                dataIndex: 'OREB',
                width: 50,
                align: 'center',
            },
            {
                title: '防守篮板',
                key: 'DREB',
                dataIndex: 'DREB',
                width: 50,
                align: 'center',
            },

            {
                title: '助攻',
                key: 'AST',
                dataIndex: 'AST',
                width: 50,
                align: 'center',
            },

            {
                title: '抢断',
                key: 'STL',
                dataIndex: 'STL',
                width: 50,
                align: 'center',
            },

            {
                title: '失误',
                key: 'TO',
                dataIndex: 'TO',
                width: 50,
                align: 'center',
            },
            {
                title: '犯规',
                key: 'FOUL',
                dataIndex: 'FOUL',
                width: 50,
                align: 'center',
            },
        ]
        onMounted(() => {
            const route = useRoute()
            date.value = route.query.type
            data_china.value = require('../../assets/word_cup_data/' + date.value + '/china_squad_data.json')
            data_japan.value = require('../../assets/word_cup_data/' + date.value + '/japan_squad_data.json')
        })

        const close = () => {
            showVideo.value = false
        }
        const hasVideo = (item) => {
            return item.value > 0
        }
        const showRow = () => {
            // if (v.videos && v.videos != undefined && v.videos.length > 0) {
            //     videos.value = v.videos.sort();
            //     videoNames.value = (v.video_name==null || v.video_name == undefined) ? []:v.video_name
            //     showVideo.value = true;
            // } else {
            //     showVideo.value = false;
            //     videos.value = [];
            //     videoNames.value = []
            // }
        }

        return {
            data,
            data_china,
            data_japan,
            showVideo,
            date,
            close,
            columns,
            hasVideo,
            showRow,
        }
    },
})
</script>

<style lang="less" scoped>
.main {
    width: 100vw;
    height: 100%;
    overflow-y: scroll;
    padding: 10px 10px;
    background: url('../../assets/bg_word_cup.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.table {
    width: 100%;
    overflow-y: auto;
    border-radius: 2px;
    background-color: white;
}

.num {
    color: #129cfe;
    cursor: pointer;
}

.num_disable {
    color: #333;
}
</style>
